import { render } from "./showReadjustmentComponent.vue?vue&type=template&id=ff11c4b2"
import script from "./showReadjustmentComponent.vue?vue&type=script&lang=js"
export * from "./showReadjustmentComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__